import { render, staticRenderFns } from "./login-site.vue?vue&type=template&id=1abe27ec&scoped=true"
import script from "./login-site.vue?vue&type=script&lang=js"
export * from "./login-site.vue?vue&type=script&lang=js"
import style0 from "./login-site.vue?vue&type=style&index=0&id=1abe27ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abe27ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/usr/src/app/components/ui/BaseButton/BaseButton.vue').default,BaseStack: require('/usr/src/app/components/ui/BaseStack/BaseStack.js').default})
